import styled from 'styled-components';
import { layouts } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces, colors } = getBaseTheme();

export const HorizontalBox = styled(layouts.HorizontalBox)`
    padding: ${spaces.inline.xs};
    font-size: ${texts.sizes.s.fontSize};
    line-height: ${texts.sizes.default.lineHeight};
    color:  ${colors.banner.error.foregroundColor};

    > div {
        width: 100%;
        margin: 0;
        
        button {
            float: right;
            min-height: 2rem;
            min-width: 2rem;
        }
        h4 {
            color: white;
        }
        span {
            ${texts.sizes.s}
        }
    }
}`;

const NotificationWrapper = styled(layouts.HorizontalBox)`
    position: absolute;
    z-index: 2;
    margin-bottom: 0rem;
    width: 100%;
`;

export const ErrorWrapper = styled(NotificationWrapper)`
    background-color: ${colors.notification.error.backgroundColor};
`;

export const WarningWrapper = styled(NotificationWrapper)`
    background-color: ${colors.notification.unread.backgroundColor};
`;
